module.exports = __webpack_public_path__ + "static/media/SatellitesIcon.242ca18d.svg";